import type { ScreenerSubField } from "epsm-api-types/models";
import type { Option } from "@/interfaces/Option";

export const flattenSubfieldsToDropdownOptions = (
	subfields: ScreenerSubField[],
	parentName = "",
	parentTitle = "",
): Option[] => {
	if (!subfields.length) return [];

	const options: Option[] = [];

	for (const subfield of subfields) {
		const fullName = parentName
			? `${parentName}.${subfield.name}`
			: subfield.name;

		const titlePrefix = parentTitle || parentName;

		const subfieldTitle =
			subfield.titleShort ?? subfield.title ?? subfield.name;

		const fullTitle = titlePrefix
			? `${titlePrefix} > ${subfieldTitle}`
			: subfieldTitle;

		if (!subfield.subFields?.length) {
			options.push({
				value: fullName,
				label: fullTitle,
			});
		} else {
			options.push(
				...flattenSubfieldsToDropdownOptions(
					subfield.subFields,
					fullName,
					fullTitle,
				),
			);
		}
	}

	return options;
};
